import React from 'react';
import { string, func, instanceOf } from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  setActiveStep,
  setSurveyDetails,
} from '../../../actions/turnkeyOmnibusActions';

import GenericButton from '../../../components/common/GenericButton';
import { ieSteps } from '../../../util/IEUtils';

const Details = ({
  ieStudies,
  surveyDetails,
  setActiveStep,
  setSurveyDetails,
  surveyLink,
}) => {
  const {
    surveyName,
    incidenceRate,
    requiredCompletes,
    productNo,
    estimatedCost,
    noOfQuestions,
    targetingCriteria,
    categoryName,
  } = surveyDetails;
  const studyName =
    ieStudies && _.find(ieStudies, item => item.pn === productNo);

  const backToProjects = () => {
    setActiveStep(ieSteps.SURVEY_LIST);
    setSurveyDetails(null);
  };

  return (
    <div className="ie--container">
      <h2 className="ie--page-title">Survey Details</h2>
      <div className="ie--details--card">
        <div className="ie--details--card-body">
          <ul className="ie--list-unstyled">
            {(studyName && studyName.sd) ? (
              <li>
                Study Selected:{' '}
                <span>
                  <strong>{studyName && studyName.sd}</strong>
                </span>
              </li>
            ) : (
              <li>
                Study Selected:{' '}
                <span>
                  <strong>Study not available</strong>
                </span>
              </li>
            )}
            <li>
              Survey Name:{' '}
              <span>
                <strong>{surveyName}</strong>
              </span>
            </li>
            {categoryName && (<li>
              Category:{' '}
              <span>
                <strong>{categoryName}</strong>
              </span>
            </li>)}
            <li>
              Targeting Criteria:{' '}
              {targetingCriteria && (
                <span>
                  <strong>{targetingCriteria}</strong>
                </span>
              )}
            </li>
            <li>
              Estimated Incidence Rate:{' '}
              <span>
                <strong>
                  {incidenceRate ? Math.round(incidenceRate) : 0}%{' '}
                </strong>
              </span>
            </li>
            <li>
              Sample Size (# of Completes):{' '}
              <span>
                <strong>{requiredCompletes || 0}</strong>
              </span>
            </li>
            <li>
              Number of Questions:{' '}
              <span>
                <strong>{noOfQuestions || 0}</strong>
              </span>
            </li>
            <li>
              Estimated Cost:{' '}
              <span>
                <strong>${estimatedCost || 0}</strong>
              </span>
            </li>
            {surveyLink && (
              <li>
                Preview Link: <strong><a href={surveyLink} target="_blank" rel="noopener noreferrer">Preview</a></strong>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="ie--details--footer">
        <GenericButton
          name="Back"
          btnStyle="ie--button ie--button-sm"
          onBtnClick={() => backToProjects()}
        />
      </div>
    </div>
  );
};

Details.propTypes = {
  surveyDetails: instanceOf(Object),
  ieStudies: instanceOf(Array),
  setActiveStep: func,
  setSurveyDetails: func,
  surveyLink: string,
};

function mapStateToProps(state) {
  return {
    ieStudies: state.turnkeyOmnibus.ieStudy.data,
  };
}

export default connect(
  mapStateToProps,
  { setActiveStep, setSurveyDetails }
)(Details);
